<!--
  ~ Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<div class="nav-group-content">
  <ng-content select="[clrVerticalNavLink]"></ng-content>
  <button
    class="nav-group-trigger"
    type="button"
    [attr.aria-expanded]="expanded"
    [attr.aria-label]="groupLabel"
    (click)="toggleExpand()"
  >
    <ng-content select="[clrVerticalNavIcon]"></ng-content>
    <div class="nav-group-text">
      <ng-content></ng-content>
    </div>
    <cds-icon
      shape="angle"
      class="nav-group-trigger-icon"
      [attr.direction]="(this.expanded) ? 'down' : 'right'"
      [attr.title]="(this.expanded) ? commonStrings.keys.collapse : commonStrings.keys.expand"
    >
    </cds-icon>
  </button>
</div>
<!--TODO: This animation needs to be added to the clr-vertical-nav-group-children component-->
<div class="nav-group-children" [@clrExpand]="expandAnimationState" (@clrExpand.done)="expandAnimationDone($event)">
  <ng-content select="[clrIfExpanded], clr-vertical-nav-group-children"></ng-content>
</div>
